import { __assign } from "tslib";
import * as React from 'react';
import { default as MuiDrawer } from '@material-ui/core/Drawer';
export var Drawer = React.forwardRef(function (props, ref) {
    var drawerLabel = props.drawerLabel, isContentRegion = props.isContentRegion;
    return (React.createElement(MuiDrawer, __assign({ PaperProps: {
            role: isContentRegion ? 'region' : 'navigation',
            'aria-label': drawerLabel,
        }, ref: ref }, props)));
});
Drawer.defaultProps = {
    isContentRegion: false,
};
export default Drawer;
//# sourceMappingURL=Drawer.js.map